enum AssignmentStatus {
  PENDING = 'pending',
  UNASSIGNED = 'unassigned',
  ASSIGNED = 'assigned',
  DONE = 'done',
  CANCELLED = 'cancelled',
}

export { AssignmentStatus };
